import { AUTH_USER, REMOVE_AUTH_USER } from "../../constants/ActionTypes";

// export const getUserData = (user) => {
//     return {
//       type: AUTH_USER,
//       payload: user
//     }
//   };

export function getUserData(user) {
  return (dispatch) => {
    dispatch({ type: AUTH_USER, user });
  };
}

export function removeUserData(user) {
  return (dispatch) => {
    dispatch({ type: REMOVE_AUTH_USER, user });
  };
}
